import React from 'react'
import styled from 'styled-components'
import { useFormContext } from 'react-hook-form'
import { QuestionnaireFormLabel } from 'spa/member/components/WorkPreference/QuestionnaireFormLabel'
import { RadioInput } from 'spa/member/components/RadioInput'
import { FormErrorMessage } from 'spa/member/components/FormErrorMessage'

export type Props = {
  name: string,
  label: string | React.ReactNode,
  annotationNote?: string | React.ReactNode,
  required?: boolean,
  options: OptionType[],
  rules?: any,
  dataCy?: string
}

type OptionType = {
  label: string,
  value: string,
}

const StyledFormContainer = styled.div`
  width: 100%;
`

export const StyledRadioForm: React.FC<Props> = (props: Props) => {
  const { formState: { errors } } = useFormContext();

  return (
    <StyledFormContainer data-cy={props.dataCy}>
      <QuestionnaireFormLabel htmlFor={props.name} label={props.label} required={props.required} annotationNote={props.annotationNote} />
      {props.options.map((option, index) => (
        <RadioInput
          key={index}
          name={props.name}
          label={option.label}
          value={option.value}
          rules={props.rules}
          required={props.required}
        />
      ))}
      {errors[props.name] && <FormErrorMessage message={String(errors[props.name]?.message)} />}
    </StyledFormContainer>
  )
}
